import { MonetizeEditor } from "../editors/monetizeEditor";
import { SelectEditor } from "../editors/selectEditor";
import { CreateableSelectEditor } from "../editors/createableSelectEditor";
import { DeploymentStatusSelectEditor } from "../editors/deploymentStatusSelectEditor";
import { DateTimeEditor } from "../editors/dateTimeEditor";
import { dateTimeRenderer } from "../renderers/dateTimeRenderer";
import { monetizeRenderer } from "../renderers/monetizeRenderer";
import { associationRenderer } from "../renderers/associationRenderer";
import { safeHTMLRenderer } from "../renderers/safeHTMLRenderer";
import { deploymentStatusRenderer } from "../renderers/deploymentStatusRenderer";
import { coloredRenderer } from "../renderers/coloredRenderer";
import { trueFalseRenderer } from "../renderers/trueFalseRenderer";

const subscriptionStatusOptions = [
  "App Submitted",
  "Graded",
  "D&A Submitted",
  "Funded",
  "Agent Paid",
  "SM Paid",
  "DSM Paid",
  "GSM Paid",
  "DM Paid",
  "Signup Bonus Due",
  "Signup Bonus Payout",
  "Deferred Subscription",
  "Completed",
].map((status) => ({ value: status, label: status }));

const trueFalseOptions = [
  { value: false, text: "No" },
  { value: true, text: "Yes" },
];

export const subscriptionColumns = [
  {
    data: "subscription_status",
    title: "Subscription Status",
    editor: SelectEditor,
    renderer: coloredRenderer,
    selectOptions: subscriptionStatusOptions,
  },
  {
    data: "deployment_status",
    title: "Deployment Status",
    url: "/deployment_statuses.json",
    editor: DeploymentStatusSelectEditor,
    renderer: deploymentStatusRenderer,
  },
  {
    data: "merchant",
    title: "Merchant",
    url: "/merchants.json",
    editor: CreateableSelectEditor,
    renderer: associationRenderer,
    objectName: "merchant",
    asyncOptions: true,
  },
  {
    data: "sales_channel",
    title: "Agent Name",
    url: "/sales_channels.json",
    editor: CreateableSelectEditor,
    renderer: associationRenderer,
    objectName: "sales_channel",
  },
  {
    data: "app_submit_date",
    title: "App Submit Date",
    dateFormat: "MM/DD/YYYY",
    renderer: dateTimeRenderer,
    editor: DateTimeEditor,
  },
  {
    data: "d_and_a_submit_date",
    title: "D&A Submit Date",
    dateFormat: "MM/DD/YYYY",
    renderer: dateTimeRenderer,
    editor: DateTimeEditor,
  },
  {
    data: "monthly_payment",
    title: "Monthly Subscription",
    editor: MonetizeEditor,
    renderer: monetizeRenderer,
  },
  {
    data: "leasing_grade",
    title: "Credit Grade",
    editor: SelectEditor,
    selectOptions: [
      { value: "A", label: "A" },
      { value: "B", label: "B" },
      { value: "C", label: "C" },
      { value: "D", label: "D" },
      { value: "E", label: "E" },
    ],
  },
  {
    data: "funding_factor",
    title: "Funding Factor",
  },
  {
    data: "funding_amount",
    title: "Funding Amount",
    renderer: monetizeRenderer,
    readOnly: true,
  },
  {
    data: "funding_date",
    title: "Funding Date",
    type: "date",
    dateFormat: "MM/DD/YYYY",
    renderer: dateTimeRenderer,
    editor: DateTimeEditor,
  },
  {
    data: "invoices",
    title: "Invoices",
    renderer: safeHTMLRenderer,
    editor: false,
    readOnly: true,
  },
  {
    data: "hardware",
    title: "Hardware",
    renderer: safeHTMLRenderer,
    editor: false,
    readOnly: true,
  },
  {
    data: "agent_price",
    title: "Agent Price",
    renderer: monetizeRenderer,
    readOnly: true,
  },
  {
    data: "cash_bonus_offered",
    title: "Bonus Offered",
    renderer: trueFalseRenderer,
    editor: SelectEditor,
    selectOptions: trueFalseOptions,
  },
  {
    data: "cash_bonus",
    title: "Cash Bonus",
    renderer: monetizeRenderer,
    readOnly: true,
  },
  {
    data: "agent_split",
    title: "Agent Commission",
    readOnly: true,
    renderer: monetizeRenderer,
  },
  {
    data: "sm_commission",
    title: "SM Commission",
    renderer: monetizeRenderer,
    editor: MonetizeEditor,
  },
  {
    data: "gsm_commission",
    title: "GSM Commission",
    renderer: monetizeRenderer,
    editor: MonetizeEditor,
  },
  {
    data: "dsm_commission",
    title: "DSM Commission",
    renderer: monetizeRenderer,
    editor: MonetizeEditor,
    readOnly: true,
  },
  {
    data: "dm_commission",
    title: "DM Commission",
    renderer: monetizeRenderer,
    editor: MonetizeEditor,
    readOnly: true,
  },
  {
    data: "sm_paid_date",
    title: "SM Paid Date",
    type: "date",
    dateFormat: "MM/DD/YYYY",
    renderer: dateTimeRenderer,
    editor: DateTimeEditor,
  },
  {
    data: "gsm_paid_date",
    title: "GSM Paid Date",
    type: "date",
    dateFormat: "MM/DD/YYYY",
    renderer: dateTimeRenderer,
    editor: DateTimeEditor,
  },
  {
    data: "dsm_paid_date",
    title: "DSM Paid Date",
    type: "date",
    dateFormat: "MM/DD/YYYY",
    renderer: dateTimeRenderer,
    editor: DateTimeEditor,
  },
  {
    data: "dm_paid_date",
    title: "DM Paid Date",
    type: "date",
    dateFormat: "MM/DD/YYYY",
    renderer: dateTimeRenderer,
    editor: DateTimeEditor,
  },
  {
    data: "contribution_margin",
    title: "Contribution Margin",
    editor: MonetizeEditor,
    renderer: monetizeRenderer,
    readOnly: true,
  },
  {
    data: "agent_paid_date",
    title: "Agent Paid Date",
    type: "date",
    dateFormat: "MM/DD/YYYY",
    renderer: dateTimeRenderer,
    editor: DateTimeEditor,
  },
  {
    data: "merchant_paid_date",
    title: "Merchant Paid Date",
    type: "date",
    dateFormat: "MM/DD/YYYY",
    renderer: dateTimeRenderer,
    editor: DateTimeEditor,
  },
  {
    data: "deferred_date",
    title: "Deferred Date",
    type: "date",
    dateFormat: "MM/DD/YYYY",
    renderer: dateTimeRenderer,
    editor: DateTimeEditor,
  },
];
